module.exports = __webpack_public_path__ + "img/rate@2x.7ecf1b94.png";